import { HubConnection } from "@microsoft/signalr";
import { Community } from "../schema/community";
import { SignalrEvent, SignalrService } from "./signalr.service";
import { ServiceHelper } from "src/app/core/helper/services.helper";
import { EventEmitter, Injectable, Output } from "@angular/core";
import { CommunitySubscription } from "../schema/cbs/community-subscription";
import { Log } from "src/app/core/log";

@Injectable({
    providedIn: 'root'
  })
export class CommunityService {

    @Output() communitySignalrEvent = new EventEmitter<SignalrEvent>();

    private connection: HubConnection;
    private signalrSub: any;
    private registeredCommunityId = 0;

    constructor(private signalrService: SignalrService) {

    }

    public async loadCommunity(communityId: number) {
        try {
            // clear subscription so we don't have it bleed over on community change
            CommunitySubscription.currentSubscription = undefined;

            // disconnect from hub
            if (this.signalrService.isConnected) {
                await this.signalrService.disconnect();
            }
            // load community and connect to hub
            await Community.load(communityId);
            await this.connectToHub();
        } finally {
            return Community.activeCommunity;
        }
    }

    private async connectToHub() {
        // Okay, we ensured that we have an auction and aren't registered for it yet
        if (Community.activeCommunity != null && this.registeredCommunityId !== Community.activeCommunity.communityId) {
            this.connection = await this.signalrService.initialize(async () => {
                // On connect..
                Log.debug('connection to community hub established');

                if (this.registeredCommunityId > 0) {
                    // unregister from the previous community
                    await this.signalrService.runCommand('DisconnectFromHub', { communityId: this.registeredCommunityId, userId: ServiceHelper.authSvc.profile.userId });
                }

                // purchaseGuid is the property, it's a bit of a hack to work with the existing code
                if ( Community.activeCommunity != null) {
                    this.registeredCommunityId = Community.activeCommunity.communityId;
                    this.signalrService.runCommand('RegisterWithHub', { communityId: this.registeredCommunityId,  userId: ServiceHelper.authSvc.profile.userId });
                }
            }, () => {
                // On disconnect..
                Log.debug('connection to community hub closed');
            });

            if (this.signalrSub == null) {
                // listen for the purchase complete event
                this.signalrService.addEventHandler(SignalREvents.CommunityUpdated);
                this.signalrService.addEventHandler(SignalREvents.TestPaymentComplete);
                this.signalrService.addEventHandler(SignalREvents.CommunitySubscriptionUpdated);

                this.signalrSub = this.signalrService.eventReceived.subscribe((signalrEvent: SignalrEvent) => {
                    if (signalrEvent.event === SignalREvents.CommunityUpdated) {
                        Log.debug('CommunityUpdated event received', signalrEvent.data);
                        const community = new Community(signalrEvent.data);
                        if (Community.activeCommunity != null && Community.activeCommunity.didSave === false) {
                            // show an alert here....
                            ServiceHelper.displayAlert(
                                'Community Updated By Another User',
                                'Another user has updated this community. Any unsaved changes will be lost.',
                            );
                            Community.activeCommunity = community;
                        }
                    } else if (signalrEvent.event == SignalREvents.CommunitySubscriptionUpdated) {
                        Log.debug('CommunitySubscriptionUpdated event received', signalrEvent.data);
                        if (CommunitySubscription.currentSubscription == null) {
                            CommunitySubscription.currentSubscription = new CommunitySubscription();
                        }
                        Object.assign(CommunitySubscription.currentSubscription, new CommunitySubscription(signalrEvent.data));
                    }
                    // emit the event to any listening page
                    this.communitySignalrEvent.emit(signalrEvent);
                });
            }
        }
    }
}

export enum SignalREvents {
    CommunityUpdated = 'CommunityUpdated',
    TestPaymentComplete = 'TestPaymentComplete',
    CommunitySubscriptionUpdated = 'CommunitySubscriptionUpdated',
}